/* eslint-disable react/require-default-props */
import React from 'react';

interface RenderHtmlProps {
  html: string;
  tag: React.ElementType;
  className?: string;
  key?: string;
  id?: string;
  style?: React.CSSProperties;
}

export default function RenderHtml({
  html,
  tag: Tag = 'span',
  className,
  key,
  id,
  style,
}: RenderHtmlProps) {
  const generateSafeKey = () =>
    `renderHtml-${(Math.random() + 1).toString(36).substring(7)}${new Date()
      .getTime()
      .toString()}`;
  const safeKey = key || generateSafeKey();
  return (
    <Tag
      key={safeKey}
      id={id}
      className={className}
      style={style}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
